<div class="sav-legal-wrap">
  <app-breadcrumb [items]="crumbs()" />

  <article class="sav-legal">
    <header class="sav-legal-head">
      <h1>{{ document().title }}</h1>
      <p class="sav-legal-updated">Last updated {{ document().updated }}</p>
      <p class="sav-legal-intro">{{ document().intro }}</p>
    </header>

    @for (section of document().sections; track section.heading) {
      <section class="sav-legal-section">
        <h2>{{ section.heading }}</h2>
        @for (block of section.body; track $index) {
          @if (isList(block)) {
            <ul>
              @for (item of block.list; track item) {
                <li>{{ item }}</li>
              }
            </ul>
          } @else {
            <p>{{ asText(block) }}</p>
          }
        }
      </section>
    }
  </article>
</div>
